import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#FDB813" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink
              target="_blank"
              href="https://www.facebook.com/Isshin-Sushi-2933466346876061/"
            >
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Isshin Sushi Restaurant Facebook"
              />
            </CFLink>
            <CFLink
              target="_blank"
              href="https://www.yelp.ca/biz/isshin-sushi-surrey"
            >
              <CFImage
                w="40px"
                pr="10px"
                src={yelp}
                alt="Isshin Sushi Restaurant Yelp"
              />
            </CFLink>
            {/* <CFLink href="https://www.zomato.com/vancouver/masita-korean-cuisine-central-burnaby-burnaby">
              <CFImage
                w="40px"
                pr="10px"
                src={zomato}
                alt="Isshin Sushi Restaurant Zomato"
              />
            </CFLink> */}
            <CFLink
              target="_blank"
              href="https://www.instagram.com/surreyisshinsushi/"
            >
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Isshin Sushi Restaurant Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#FDB813" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink
              target="_blank"
              href="https://www.facebook.com/Isshin-Sushi-2933466346876061/"
            >
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Isshin Sushi Restaurant Facebook"
                hover
              />
            </CFLink>
            <CFLink
              target="_blank"
              href="https://www.yelp.ca/biz/isshin-sushi-surrey"
            >
              <CFImage
                w="40px"
                pr="10px"
                src={yelp}
                alt="Isshin Sushi Restaurant Yelp"
                hover
              />
            </CFLink>
            {/* <CFLink href="https://www.zomato.com/vancouver/masita-korean-cuisine-central-burnaby-burnaby">
              <CFImage
                w="40px"
                pr="10px"
                src={zomato}
                alt="Isshin Sushi Restaurant Zomato"
                hover
              />
            </CFLink> */}
            <CFLink
              target="_blank"
              href="https://www.instagram.com/surreyisshinsushi/"
            >
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Isshin Sushi Restaurant Instagram"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
